import AbstractEntity from "./abstractEntity";

/*
messageObj properties:
  - id: string
  - when: Date
  - messageType: string
  - fromUser: string (username)
  - fromType: string
  - fromObj: string
  - toType: string
  - toObj: string
  - [subject]: string
  - [content]: string
  - [replyToMessage]: string (message.id)
*/
class Message extends AbstractEntity {
  /**
   *
   * @param {object} messageObj
   * @param {UserInfo} userInfo
   */
  // constructor(messageObj, userInfo) {
  //   super(messageObj, userInfo);
  // }

  /**
   *
   * @returns {boolean}
   */
  asCommish() {
    return (
      this.obj.fromType === "LeagueSeason" &&
      this.obj.fromObj === this.obj.toObj
    );
  }
}

export default Message;
